module.exports = __webpack_public_path__ + "img/pay-loading.66bdad7c.png";